export const HomeIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      // eslint-disable-next-line max-len
      d="M2.5 8.80423C2.5 8.3256 2.5 8.08628 2.56169 7.86589C2.61633 7.67067 2.70614 7.48705 2.82669 7.32406C2.96278 7.14006 3.15168 6.99314 3.52949 6.69929L9.18141 2.30335C9.47418 2.07564 9.62057 1.96178 9.78221 1.91802C9.92484 1.8794 10.0752 1.8794 10.2178 1.91802C10.3794 1.96178 10.5258 2.07564 10.8186 2.30335L16.4705 6.69929C16.8483 6.99314 17.0372 7.14006 17.1733 7.32406C17.2939 7.48705 17.3837 7.67067 17.4383 7.86589C17.5 8.08628 17.5 8.3256 17.5 8.80423V14.8333C17.5 15.7668 17.5 16.2335 17.3183 16.59C17.1586 16.9036 16.9036 17.1586 16.59 17.3183C16.2335 17.5 15.7668 17.5 14.8333 17.5H5.16667C4.23325 17.5 3.76654 17.5 3.41002 17.3183C3.09641 17.1586 2.84144 16.9036 2.68166 16.59C2.5 16.2335 2.5 15.7668 2.5 14.8333V8.80423Z"
      stroke={props.color || 'var(--allie-color-neutral-60)'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
